import { useEffect, useState } from "react";

// Small, local debounce — not meant to be more general-purpose than the
// instructor-availability query key needs. Debounces on a serialized
// snapshot of `value`, not the reference itself: an object literal built
// fresh on every render (e.g. { instructorId, classId, startDate, rrule })
// would otherwise be seen as "changed" every render, resetting the timer
// and never actually settling.
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  const serialized = JSON.stringify(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized, delayMs]);

  return debounced;
}
